import React from 'react'
import { Typography, Box } from '@material-ui/core'

import useStyles from './styles'

const SectionTitle = ({ title, centered }) => {
  const { root, title: titleClass } = useStyles({ centered })
  return (
    <Box className={root}>
      <Typography className={titleClass}>{title}</Typography>
    </Box>
  )
}

export default SectionTitle
